import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0.001, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Label = ({ children, light }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.22em] ${light ? "text-slate-300" : "text-slate-500"}`}>
    {children}
  </p>
);
